<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">

        <button *ngIf='!isList' routerLink="/templates" title="{{ 'inputs.back' | translate }}" mat-icon-button>
          <mat-icon>keyboard_backspace</mat-icon>
          {{ 'inputs.back' | translate }}
        </button>

        <h1 *ngIf='isList'>{{ 'titles.list.template' | translate }}</h1>
        <h1 *ngIf='!isList'>{{ 'titles.edit.template' | translate }}</h1>
        <div *ngIf='!isList && !isNew'>
          {{ 'inputs.creation_date' | translate }}: {{creation_date | date:'d/M/Y, H:MM:ss'}} <br>
          {{ 'inputs.modification_date' | translate }}: {{modification_date | date:'d/M/Y, H:MM:ss'}}
        </div>


        <div class="media-body">

          <mat-form-field *ngIf='isList'>
            <mat-label>{{ 'inputs.search' | translate }}</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'inputs.search' | translate }}" #input>
          </mat-form-field>
          <div *ngIf='isList'>
            <table mat-table [dataSource]="dataSource" matSort>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)"> {{element.name}} </td>
              </ng-container>

              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.type' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{element.type }} </td>
              </ng-container>

              <ng-container matColumnDef="modification_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.modification_date' |
                  translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm>
                  {{element.modification_date | date: 'yyyy-MM-dd H:mm:ss'}} </td>
              </ng-container>

              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef style="width: 18% !important"> {{ 'tables.actions' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="Click to Delete" class="iconbutton"
                  (click)="delete(element.id)" color="warn">
                  <mat-icon>delete</mat-icon>
                </button> -->
                  <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}" (click)="goTo(element.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Send test email" (click)="sendEmailTest(element.id)">
                    <mat-icon>send</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'buttons.delete' | translate}}" (click)="deleteTemplate(element.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'buttons.duplicate_template' | translate}}" (click)="duplicateTemplate(element.id)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showTemplatesProgressBar">{{ 'tables.loading' | translate }}</span>
                  <span *ngIf="!showTemplatesProgressBar">{{ 'tables.no_data_found' | translate}}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar *ngIf="showTemplatesProgressBar" mode="indeterminate"></mat-progress-bar>
            <mat-paginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[100, 10, 20,50]" showFirstLastButtons></mat-paginator>

          </div>


          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" [formGroup]="templateForm" *ngIf='!isList'>
            <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
            <mat-form-field>
              <input matInput required [formControlName]="'name'" type="text"
                placeholder="{{ 'inputs.name' | translate }}">
            </mat-form-field>

            <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.type' | translate }}</mat-label>
              <mat-select matNativeControl required [formControlName]="'type'">
                <mat-option value="new_photo">{{ 'inputs.new_photo' | translate }}</mat-option>
                <mat-option value="reminder">{{ 'inputs.reminder' | translate }}</mat-option>
                <mat-option value="order">{{ 'inputs.order' | translate }}</mat-option>
                <mat-option value="new_password">{{ 'inputs.new_password' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <input matInput required [formControlName]="'subject_es'" type="text"
                placeholder="{{ 'inputs.subject_es' | translate }}">
            </mat-form-field>
            <div style="width: 100%;"> <label>Contenido del correo en Español</label>
              <mat-icon [data-html]="'True'" matTooltip="{name} --> Nombre del usuario
                    {email} --> Correo del usuario
                    {new_password} --> Enlace para generar nueva contraseña" [matTooltipClass]="'my-tooltip'"
                [matTooltipPosition]="'left'" style="float: right;">info
              </mat-icon>
            </div>

            <angular-editor id="editor_es" [ngModel]="html" [formControlName]="'editor_es'" [config]="config">
            </angular-editor>

            <br>
            <mat-divider style="margin:20px 0px"></mat-divider>
            <mat-form-field>
              <input matInput required [formControlName]="'subject_cat'" type="text"
                placeholder="{{ 'inputs.subject_cat' | translate }}">
            </mat-form-field>
            <div style="width: 100%;"> <label>Contingut del correu en Català</label>
              <mat-icon [data-html]="'True'" matTooltip="{name} --> Nom de l'usuari
                    {email} --> Correu de l'usuari
                    {new_password} --> Enllaç per generar nova contrasenya" [matTooltipClass]="'my-tooltip'"
                [matTooltipPosition]="'left'" style="float: right;">info
              </mat-icon>
            </div>

            <angular-editor id="editor_cat" [ngModel]="html" [formControlName]="'editor_cat'" [config]="config">
            </angular-editor>

            <br>
            <mat-divider style="margin:20px 0px"></mat-divider>

            <mat-form-field>
              <input matInput required [formControlName]="'subject_en'" type="text"
                placeholder="{{ 'inputs.subject_en' | translate }}">
            </mat-form-field>
            <div style="width: 100%;"> <label>Mail content in English</label>
              <mat-icon [data-html]="'True'" matTooltip="{name} --> User's name 
                    {email} --> User's email
                    {new_password} --> Link to generate new password" [matTooltipClass]="'my-tooltip'"
                [matTooltipPosition]="'left'" style="float: right;">info
              </mat-icon>
            </div>

            <angular-editor id="editor_en" [ngModel]="html" [formControlName]="'editor_en'" [config]="config">
            </angular-editor>


            <!-- <mat-form-field>
                <input matInput type="password" placeholder="Password" formControlName="password" (input)="onPasswordInput()">
                <mat-error *ngIf="password.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="password.hasError('minlength')">Password must have at least {{minPw}} characters</mat-error>
              </mat-form-field>
            
              <mat-form-field>
                <input matInput type="password" placeholder="Confirm password" formControlName="password2" (input)="onPasswordInput()">
                <mat-error *ngIf="password2.hasError('required')">Please confirm your password</mat-error>
                <mat-error *ngIf="password2.invalid && !password2.hasError('required')">Passwords don't match</mat-error>
              </mat-form-field>
              <br> -->


          </div>
          <!-- </mat-card> -->


          <div class="float-button-container" *ngIf='isList'>
            <button mat-fab color="primary" aria-label="add" (click)="newTemplate()">
              <mat-icon>plus_one</mat-icon>
            </button>
          </div>
          <div class="float-button-container" *ngIf='!isList'>
            <button mat-fab color="primary" aria-label="save" (click)="saveTemplate()">
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>


</div>